import styled from '@emotion/styled'

import { calcRem } from '../../__styling/style-functions/calc-rem'
import { metrics } from '../../__styling/settings/metrics'
import { colors } from '../../__styling/settings/colors'
import { zIndex } from '../../__styling/settings/z-index'
import { themedValue } from '../../__styling/themed-value'
import { ThemeMargins } from '../../__styling/settings/metrics'

export interface GridProps {
    verticalSpacing: keyof ThemeMargins | undefined
    stickyOffset?: number
    // "as" this is available on emotion 10 but we are currently overloading with emotion 9 to save build time
    // https://emotion.sh/docs/styled
    as?: string
}

export const StyledJuliet = styled('div')<GridProps>(
    {
        margin: '0 auto',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
    },
    ({ stickyOffset, verticalSpacing, theme }) => [
        {
            marginBottom:
                verticalSpacing &&
                calcRem(metrics[theme.kind].margins[verticalSpacing]),
        },
        stickyOffset !== undefined && {
            position: 'sticky',
            top: `${stickyOffset}px`,
        },
    ],
)

export const StyledHeader = styled('div')(
    {
        display: 'block',
        width: '100%',
    },
    ({ theme }) => ({
        marginBottom: calcRem(metrics[theme.kind].margins.md),
    }),
)

export const StyledGridItem = styled('div')(
    {
        display: 'flex',
        justifyContent: 'flex-start',
        flexGrow: 1,
        flexShrink: 1,
        width: '100%',
        maxWidth: '100%',
        alignItems: 'stretch',
        flex: '0 0 auto',
        position: 'relative',
    },
    ({ theme }) => ({
        marginBottom: calcRem(metrics[theme.kind].margins.sm),

        '&:last-child': {
            marginBottom: '0',
        },

        // Adds horizontal dividers
        '&::before': {
            content: themedValue(theme, {
                thewest: `''`,
                perthnow: `''`,
                sevennews: undefined,
            }),
            backgroundColor: themedValue(theme, {
                thewest: colors.thewest.greyDolphin,
                perthnow: colors.perthnow.greyMarble,
                sevennews: undefined,
            }),
            width: '100%',
            height: 1,
            position: 'absolute',
            left: 0,
            bottom: 0,
            zIndex: zIndex.common.collectionDividers,
        },

        // only have horizontal divider on last card on perthnow
        '&:last-child::before': {
            content: themedValue(theme, {
                thewest: 'none',
                perthnow: `''`,
                sevennews: undefined,
            }),
        },

        '> .PortraitCard': {
            alignItems: 'flex-start',
        },
    }),
)
